import { render } from "./PresentationPage-March26.vue?vue&type=template&id=e9f02408"
const script = {}

import "./PresentationPage-March26.vue?vue&type=style&index=0&id=e9f02408&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__